/**
 *  催付记录汇总
 */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import LzNotice from '@/components/common/LzNotice';
import { Button, DatePicker, Form, Input, Select, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import styles from './index.module.scss';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import LzMsg from '@/components/common/LzMsg';

const PaymentRecord = () => {
  const [isLoading, setLoading] = useState(false);
  // 活动form查询条件
  const [formSelect, setFormSelect] = useState({
    taskName: '', // 任务名称
    orderNumber: '', // 订单号
    startTime: '', // 活动开始时间
    endTime: '', // 活动结束时间
    sendState: '', // 发送状态
    paymenType: '', // 催付类型
  });
  // 获取列表信息
  const [dataList, setDataList] = useState([]);
  // 获取催付订单数/成功短信数
  const [orderSandSmsAmount, setOrderSandSmsAmount] = useState({ ordersCount: 0, smsCount: 0 } as object);
  // 发送状态下拉框选项
  const sendStateOption = [
    { label: '全部', value: '' },
    { label: '发送成功', value: '1' },
    { label: '发送失败', value: '0' },
  ];
  // 催付类型下拉框选项
  const paymenTypeOption = [
    { label: '全部', value: '' },
    { label: '首次催付', value: 'S_CFTX' },
    { label: '二次催付', value: 'S_CFT2' },
  ];
  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  // 翻页方法
  const handleTaskPageSizeChange = async (pages = {}) => {
    // setLoading(true);
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      // TODO 请求后端列表接口
      searchList({ pageSize: pages.pageSize, pageNo: pages.pageNo });
    } catch (e) {
      // setLoading(false);
      LzMsg.error(e.message);
    }
  };
  // 选择时间
  const selectTime = (value) => {
    let startT = '';
    let endT = '';
    startT = value[0] ? moment(value[0]).format('YYYY-MM-DD') : '';
    endT = value[1] ? moment(value[1]).format('YYYY-MM-DD') : '';
    setFormSelect({ ...formSelect, startTime: startT, endTime: endT });
  };
  // 选择发送状态
  const chooseSendStatus = (v) => {
    setFormSelect({ ...formSelect, sendState: v });
  };
  // 选择催付类型
  const choosePaymenType = (v) => {
    setFormSelect({ ...formSelect, paymenType: v });
  };
  const search = () => {
    setPageInfo({
      ...pageInfo,
      pageNo: 1,
    });
    searchList({ pageNo: 1 });
    searchAmount();
  };
  // 查询获取列表
  const searchList = (v) => {
    // setLoading(true);
    const params = {
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      taskName: formSelect.taskName,
      orderId: formSelect.orderNumber,
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
      sendStatus: formSelect.sendState,
      taskType: formSelect.paymenType,
      ...v,
    };


    Servlets('getPaymentRecordList', params).then((res) => {
      if (!res.data) {
        setLoading(false);
        return;
      }
      setDataList(res.data);
      setPageInfo({ ...pageInfo, total: res.page.total, pageNo: res.page.pageNo, pageSize: res.page.pageSize });
      // setLoading(false);
    });
  };
  const searchAmount = (v) => {
    const params = {
      taskName: formSelect.taskName,
      orderId: formSelect.orderNumber,
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
      sendStatus: formSelect.sendState,
      taskType: formSelect.paymenType,
      ...v,
    };
    Servlets('getPaymentAmount', params).then((res: { data: object }) => {
      setOrderSandSmsAmount(res.data ? res.data : orderSandSmsAmount);
    });
  };
  // 重置查询条件
  const resetFilter = () => {
    setFormSelect({
      taskName: '', // 任务名称
      orderNumber: '', // 订单号
      startTime: '', // 活动开始时间
      endTime: '', // 活动结束时间
      sendState: '', // 发送状态
      paymenType: '', // 催付类型
    });
    setPageInfo({
      ...pageInfo,
      pageNo: 1,
    });
    searchList({ pageNo: 1, taskName: '', orderId: '', startTime: '', endTime: '', sendStatus: '', taskType: '' });
    searchAmount({ taskName: '', orderId: '', startTime: '', endTime: '', sendStatus: '', taskType: '' });
  };
  const downLoad = () => {
    if (dataList.length > 0) {
      const params = {
        taskName: formSelect.taskName,
        orderId: formSelect.orderNumber,
        startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
        endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
        sendStatus: formSelect.sendState,
        taskType: formSelect.paymenType,
      };
      Servlets('getRecordExcelout', params).then((res) => {
        utils.downloadFile(res);
      });
    } else {
      LzMsg.error('无法导入，数据为空');
    }
  };
  useEffect(() => {
    search();
  }, []);
  return (
    <div className="page-Padding">
      <LzNotice cotent="提示：统计了首次和二次催付所有任务的催付记录" />

      <div className={styles.listSearch}>

        <Form inline style={{ marginTop: '30px' }} className={styles.listSearchForm} size="medium">

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
            <Form.Item className={styles.formItem}>
              <span style={{ marginRight: '15px' }}>  任务名称: </span>
              <Input
                name="taskName"
                trim
                value={formSelect.taskName}
                className={styles.formItem_width}
                onChange={(v) => setFormSelect({ ...formSelect, taskName: v })}
                placeholder="请输入任务名称"
                size="small"
              />
            </Form.Item>
            <Form.Item hasFeedback className={styles.formItem} style={{ paddingLeft: '5%' }}>
              <span style={{ marginRight: '15px' }}>发送时间: </span>
              <DatePicker.RangePicker
                popupAlign="tr tr"
                value={[formSelect.startTime, formSelect.endTime]}
                onChange={selectTime}
                className={styles.formItem_width}
                followTrigger
              />
            </Form.Item>
            <Form.Item className={styles.formItem} style={{ textAlign: 'right' }}>
              <span style={{ marginRight: '15px' }}>订单号: </span>
              <Input
                name="orderNumber"
                trim
                value={formSelect.orderNumber}
                className={styles.formItem_width}
                onChange={(v) => setFormSelect({ ...formSelect, orderNumber: v })}
                placeholder="请输入订单号"
                size="small"
              />
            </Form.Item>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginTop: '15px',
            marginBottom: '20px',
          }}
          >
            <Form.Item className={styles.formItem}>
              <span style={{ marginRight: '15px' }}>发送状态:</span>
              <Select
                value={formSelect.sendState}
                dataSource={sendStateOption}
                onChange={chooseSendStatus}
                className={styles.formItem_width}
                followTrigger
              />
            </Form.Item>
            <Form.Item className={styles.formItem} style={{ paddingLeft: '5%' }}>
              <span style={{ marginRight: '15px' }}>催付类型: </span>
              <Select
                value={formSelect.paymenType}
                dataSource={paymenTypeOption}
                onChange={choosePaymenType}
                className={styles.formItem_width}
                followTrigger
              />
            </Form.Item>
            <Form.Item className={styles.formItem} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                className={`${styles.submitBtnStyle_width} ${styles.submitBtnStyle_marginRight}`}
                onClick={() => search()}
              >查询
              </Button>
              <Button
                type="normal"
                className={`${styles.submitBtnStyle_width}`}
                onClick={resetFilter}
              >重置
              </Button>
            </Form.Item>
          </div>
        </Form>

      </div>

      <div className={styles.childBox}>

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          marginBottom: '15px',
          marginTop: '10px',
        }}
        >
          <div>
            <span>催付订单总数：<span
              style={{ color: '#FF3333' }}
            >{orderSandSmsAmount.ordersCount || 0}
                         </span>单
            </span>
            <span style={{ marginLeft: '20px' }}>成功短信数：<span
              style={{ color: '#FF3333' }}
            >{orderSandSmsAmount.smsCount || 0}
            </span>条
            </span>
          </div>
          <Button type="primary" className={`${styles.w88}`} onClick={downLoad}>导出</Button>
        </div>
        <Table dataSource={dataList} loading={isLoading} className={styles.customTable}>
          <Table.Column
            width="12%"
            title="订单号"
            align="left"
            cell={(value, index, item) => (
              <div style={{ whiteSpace: 'nowrap' }}>{item.orderId}</div>
            )}
          />
          <Table.Column width="15%" title="任务名称" align="left" dataIndex="taskName" />
          <Table.Column title="短信内容" align="left" dataIndex="smsContent" />
          <Table.Column
            width="10%"
            title="字数/计费"
            align="left"
            cell={(value, index, item) => (
              <div>{item.smsWordsNum}/<span style={{ color: '#FF3333' }}>{item.smsNum}</span></div>
            )}
          />
          <Table.Column
            title="发送时间"
            width="13%"
            align="left"
            cell={(value, index, item) => (
              <div className={styles.payNum}>{moment(item.sendTime).format('YYYY-MM-DD HH:mm:ss')}</div>
            )}
          />
          <Table.Column
            title="催付类型"
            width="8%"
            align="left"
            cell={(value, index, item) => (
              <div>
                {
                item.functionName === 'S_CFTX' && <span>首次催付</span>
              }
                {
                item.functionName === 'S_CFT2' && <span>二次催付</span>
              }
              </div>
            )}
          />
          <Table.Column
            title="状态"
            width="8%"
            align="left"
            cell={(value, index, item) => (
              <div>
                {
                item.sendStatus === 1 && <span style={{ color: '#00BB66' }}>发送成功</span>
              }
                {
                item.sendStatus === 0 && <span style={{ color: '#FF3333' }}>发送失败</span>
              }
              </div>
            )}
          />
          <Table.Column
            title="备注"
            width="8%"
            align="left"
            cell={(value, index, item) => (
              <div>
                {
                item.remark ? (<span style={{ color: '#FF3333' }}>{item.remark}</span>) : (
                  <span>--</span>)
              }
              </div>
            )}
          />
        </Table>
        <LzPagination pageInfo={pageInfo} onChange={handleTaskPageSizeChange} />

      </div>
    </div>
  );
};

export default PaymentRecord;
